<template>
  <div>
    <h2 class="title">
      Reviews
    </h2>
    <hr />
    <div
      class="reviewContainer"
      :style="{'overflow-y': showMore ? 'auto' : 'hidden' }"
    >
      <div v-for="(review, index) in reviewList" :key="index">
        <ReviewCard
          :name="review.name"
          :rating="review.rating"
          :content="review.content"
          class="review"
        />
      </div>
    </div>
    <div class="has-text-centered">
      <a
        v-if="reviewList.length > 2"
        class="button is-rounded is-large range-button reviewButtons"
        :class="{ 'active-range-button': showMore }"
        
        @click="showMore = !showMore"
        >{{ showMore ? 'See Less' : 'See More' }}</a
      >
      <a
        id="create-review-button"
        class="button is-large search-button slide-left reviewButtons"
        
        @click="openModal()"
        target="_blank"
        >Leave a review</a
      >
    </div>
    <transition name="fade">
      <CreateReview
        v-if="active"
        :active="active"
        :gym_id="gymId"
        :gym_name="gymName"
        @closeReviewModal="closeReview()"
      />
    </transition>
  </div>
</template>

<script>
import ReviewCard from '../molecules/ReviewCard';
import CreateReview from '../molecules/CreateReview';
export default {
  components: {
    ReviewCard,
    CreateReview,
  },
  data() {
    return {
      reviews: [],
      sortedReviews: [],
      showMore: false,
    };
  },
  methods: {
    closeReview() {
      this.active = false;
      this.$emit('closeReview');
      this.getReviews();
    },
    async getReviews() {
      let response = await this.$http.get(`/api/reviews/gym/${this.gymId}`);
      this.review = response.data;
      this.sortedReviews = response.data.sort((a, b) => {
        return b.rating - a.rating;
      });
    },
    openModal() {
      this.active = !this.active;
    },
  },
  async mounted() {
    let gymIdLocal;
    if (!this.gymId) {
      gymIdLocal = this.$route.params.id;
    } else {
      gymIdLocal = this.gymId;
    }
    let response = await this.$http.get(`/api/reviews/gym/${gymIdLocal}`);
    this.review = response.data;
    this.sortedReviews = response.data.sort((a, b) => {
      return b.rating - a.rating;
    });
  },
  computed: {
    reviewList() {
      return this.showMore
        ? this.sortedReviews
        : this.sortedReviews.slice(0, 2);
    },
  },
  props: {
    gymId: Number,
    gymName: String,
    website: String,
    active: Boolean,
  },
};
</script>

<style scoped>
.review {
  height: 8rem;
}

.reviewContainer {
  max-height: 25rem;
}

.reviewButtons {
  width: 15rem; 
  margin: 1rem;
}

h2 {
  padding: 1rem;
}

div.reviewContainer::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
  border-radius: 10px;
  background-color: #f5f5f5;
}

div.reviewContainer::-webkit-scrollbar {
  width: 12px;
  border-radius: 10px;
  background-color: #f5f5f5;
}

div.reviewContainer::-webkit-scrollbar-thumb {
  border-radius: 10px;
  /* box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
  background-color: #00c5fd;
}

@media only screen and (max-width: 768px) {
  .title {
    font-size: 1.5rem;
    margin-left: 1rem;
    padding: 0;
    font-weight: 600;
  }
}
</style>
